module.exports = __webpack_public_path__ + "static/media/fast-icon.5b470e58.svg";